import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { reportClientError } from "../../utils/errorMonitoring";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("XFOLYO render error", error, info);
    reportClientError(error, { componentStack: info?.componentStack });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="min-h-screen bg-[#f7f7f6] text-[#232124] flex items-center justify-center p-6 font-sans">
        <section className="w-full max-w-lg border border-[#e4e1df] bg-white rounded-xl p-8 md:p-10 text-left" role="alert">
          <div className="w-11 h-11 rounded-lg bg-amber-50 text-amber-700 grid place-items-center mb-6"><AlertTriangle size={22} aria-hidden="true" /></div>
          <p className="text-[11px] font-black uppercase tracking-widest text-amber-700 mb-2">SYSTEM NOTICE</p>
          <h1 className="text-2xl md:text-3xl font-black tracking-tight">หน้านี้โหลดไม่สำเร็จ</h1>
          <p className="mt-3 text-sm leading-7 text-slate-600">ข้อมูลที่บันทึกไว้ไม่ได้ถูกลบ ลองโหลดหน้าใหม่อีกครั้ง หากยังพบปัญหา โปรดติดต่อ xfolyopro@outlook.com</p>
          <button type="button" onClick={() => window.location.reload()} className="mt-7 min-h-11 px-5 rounded-lg bg-[#241e20] text-white text-xs font-black inline-flex items-center gap-2">
            <RefreshCw size={15} aria-hidden="true" /> โหลดหน้าใหม่
          </button>
        </section>
      </main>
    );
  }
}
